
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faq7MYgUQBnMgAYYt8dJwCgKK5bJ9hOb6mjLVAv8m_pLLEMeta } from "/codebuild/output/src2313071595/src/src/pages/faq.vue?macro=true";
import { default as menuqQlMEDvPcKB943_45yYAF52l4Hfmb3Yne3DV3lrb3N414Meta } from "/codebuild/output/src2313071595/src/src/pages/menu.vue?macro=true";
import { default as indexoVohuQXu_JBocmcsE1dUIFdbCFqTu1rm8rCpD1HGTPkMeta } from "/codebuild/output/src2313071595/src/src/pages/index.vue?macro=true";
import { default as contactxYi18oF1ndodMOzT3_45tWIeJW5HoayEh1K06BB4SGf3oMeta } from "/codebuild/output/src2313071595/src/src/pages/contact.vue?macro=true";
import { default as tutorialO66vC1RB8L9a5c1wPnNMCquaStwAbYfyV9Jns1hFa00Meta } from "/codebuild/output/src2313071595/src/src/pages/tutorial.vue?macro=true";
import { default as agreementsOm_TNZt2FyLu1Ss3z1yjiZSyiGP_45ute4DFhFM2AKZ8Meta } from "/codebuild/output/src2313071595/src/src/pages/agreement.vue?macro=true";
import { default as about_45passuBqyOAsCQAHFGgAroZep2SUENzbiiXA9DYWyLKrAWjYMeta } from "/codebuild/output/src2313071595/src/src/pages/about-pass.vue?macro=true";
import { default as indexnU4TJWtmEZo8PezbkZzLqQI_45XMAy1jr7i2mZLRp9OWEMeta } from "/codebuild/output/src2313071595/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93Z9UTmK6QEqVPdFmBG1yxQ1DG5mWv7KLiTcZiSXBRD30Meta } from "/codebuild/output/src2313071595/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceX0NTljEaIaaa9EBOOpUaGA_45j7AaPHXL0rv1Z20ObaoYMeta } from "/codebuild/output/src2313071595/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93kjffF2YOgRg_452RG0aw2LrwCfFWIsi72Ccm_KLdTJVXEMeta } from "/codebuild/output/src2313071595/src/src/pages/notice/[id].vue?macro=true";
import { default as index3Ie0WxQTbyVU24DKFw38rTOspsnqllldF907DPXE6ycMeta } from "/codebuild/output/src2313071595/src/src/pages/coupon/index.vue?macro=true";
import { default as indexsQIwd_45WMu8afnR__459iIJKEvnLpCmwHLK1hG9uivPx_45YMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/index.vue?macro=true";
import { default as indexmu1Gt6LmUwiw5zhGB3X_45yXXJg_45fCyRZ9dfJiMMlYgV0Meta } from "/codebuild/output/src2313071595/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93cpT9_Aicg1SqT1Xciyd4nS0P6_45xM2XC2_45LgM_45Zk8rLIMeta } from "/codebuild/output/src2313071595/src/src/pages/parking/[id].vue?macro=true";
import { default as indexZQlSNW524h495Xh3smr8qWSdHR9wya_45Ry30xIDv8Ce4Meta } from "/codebuild/output/src2313071595/src/src/pages/history/index.vue?macro=true";
import { default as indexEPwm5M46YaSIf4XaGsnIVzvdMDYMrOiQ6gZ70kbc2jYMeta } from "/codebuild/output/src2313071595/src/src/pages/monthly/index.vue?macro=true";
import { default as indexoOTLeD5chTibuQfU_45fSDV7BJGE_znZR5Zh_45vKIRYz10Meta } from "/codebuild/output/src2313071595/src/src/pages/sign-in/index.vue?macro=true";
import { default as index6rUMSoM6AXNjPV37111bkLAl20VNuyndd5XTvR7WkqIMeta } from "/codebuild/output/src2313071595/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavidHMV_451nMjz9wqs_9hIwErDNl2C1Zw1dWMJPZlYJcTCAMeta } from "/codebuild/output/src2313071595/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editTBXkT3IBC1s2V9zzniT7dLmnikmXyrmHQo19Xv17rXQMeta } from "/codebuild/output/src2313071595/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementsHnBnnxnQ0K9x857qBQQrQQ9nM6sG_45_1FKMuQd6S7wAMeta } from "/codebuild/output/src2313071595/src/src/pages/pass-agreement.vue?macro=true";
import { default as index_MqhDFOmB_45V4GlBZndI4mZDmlqX5nspaK57wzCQZKZMMeta } from "/codebuild/output/src2313071595/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dAS6nAmTv65DUYJLdDp2yPLgVp5ZL93kIH_UAN4ogh5wMeta } from "/codebuild/output/src2313071595/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmWsLCOugZNfs_c0YBSWjgEHM3upjiaN8EITzQU_lbuQQMeta } from "/codebuild/output/src2313071595/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexskbMtuKhsLAPQJhMNSvouZfWVfMn4_6KHBEUBLrfpEAMeta } from "/codebuild/output/src2313071595/src/src/pages/card/create/index.vue?macro=true";
import { default as indexqeTNgYQfzn3i3SFNjt9BW4R3nG08Z2wRR_45JzjNU_45BoIMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmbQeoYNiMbUNqh2IFls7t2D4TYpkvT_45CRr28JGWo0V2sMeta } from "/codebuild/output/src2313071595/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmHQaWkGgQ46AsqE_e0icjAu2x8Yo_wLa5avHbCFwFn9EMeta } from "/codebuild/output/src2313071595/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete4TsCusak5G4fSUNHSqoEEvRSfA5gdfmx9Zrl9YzUQ4wMeta } from "/codebuild/output/src2313071595/src/src/pages/membership/complete.vue?macro=true";
import { default as registerPbrNiR2q7N9NZVOJ_BlQl3O_mzJFtih6tnibcVgWi6kMeta } from "/codebuild/output/src2313071595/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_9368n8nt6X0fTgzvFAc6VrbOf0yNgduSrG_Wqda1o7AvUMeta } from "/codebuild/output/src2313071595/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmV8QwkuhLl4AxxmxFRQiN5J1thI3Nsc7XkfQs1GSzKagMeta } from "/codebuild/output/src2313071595/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93LkwhgZxJSTE4kBSxntrff7GwAGIiuClVLSfVq9acZfcMeta } from "/codebuild/output/src2313071595/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexUq2UAKAj3tZofPsCimrScV5f66G27V_45exjrY7GzWYhQMeta } from "/codebuild/output/src2313071595/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeYuy5CsXM431uxWyDbgpJVK7Cz4ZTNghgLQC06U3bzHAMeta } from "/codebuild/output/src2313071595/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeVoqDKjH_4582Kjo16dK12mWfAvZGE_yQ3UCGdALAS7UrYMeta } from "/codebuild/output/src2313071595/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completetyuUtbJUVwWtuHYh5NYlcaJ6lZDHD3dXsku5spozLHIMeta } from "/codebuild/output/src2313071595/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerI6pXSx_45mILB7ARQD_QEJxWVv9xguUb7U4GPF6O9idgcMeta } from "/codebuild/output/src2313071595/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeS0C9sw9sru0qCx6r1Vei21nUcKPM3d5TtzXD2sw2SkwMeta } from "/codebuild/output/src2313071595/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexX8YReLZhM_P5pd_45Q7YJYovwg5gTQqTjV1EzvICFYznoMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmaIuAPsnK8jQl4I5N56JAo4mV4V8chLf8SlrXizITvqQMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completepF_45De4Oo2l1_45Vj7a97pCMUXUJm8ZVNhuJJRSi_45IFvLcMeta } from "/codebuild/output/src2313071595/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexd6GySj83Af86sU_5n1ixIkO0Hw4j4r5XNBNVi21qtpAMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93_45WyBxBO9MPE78AbnIUyDvDoUq3agDnjlElj95W2xvccMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete2myI0Op9MA_zHXYviEiiU_f0GC9Gn0qqrMt5Zac5H5wMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias48FTWDZfM_45mLOjGABJpvNxMpi0Lbw3FK01C6KtRhDt0Meta } from "/codebuild/output/src2313071595/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampley7ySD_c4mU1kMsSeWjzbNwEDPYUtmm2l_45kY1rKCV0FYMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailx3SQ89qcwXSUEENUsSqwIT0KA0eKGfOE6KZSrVViFxQMeta } from "/codebuild/output/src2313071595/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmOgSUQ_xkWg36hPnkUxKIbXf2KKBBGi3xFFWYBGdZpkAMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentpt0yGOKsd_45BWld4_45m6JJwUYH_LXEGRUVlpNkFVPKhlcMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm9FvGMjdW7ewZ4IpQKjKDVMGRiCkY4zTCUd_45VQwX36ScMeta } from "/codebuild/output/src2313071595/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate2dAfoQDv_459htWXqR07BKCre6Ai_rfqzf18kQCMzkmMkMeta } from "/codebuild/output/src2313071595/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete_GxG6h_45Q70y_45sIQpxEnSnMN_Gdvt3isFbg7oqRZHulgMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code0Maw_45dTkcq7T5dyRk_452FZK1jOqZavBf58ZM_45NRlpzUUMeta } from "/codebuild/output/src2313071595/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password8OTQIhELSxIVna3HCdSo_lwbcNeWmQ8L7EqYG8uGAkIMeta } from "/codebuild/output/src2313071595/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasyAX7C1HUwn5p1aPm8D8P0Hp2so5uOZXYgIfqLlmjZ5AMeta } from "/codebuild/output/src2313071595/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerFwN1WLEz_45wXnBMZyjRe180qGDT9TN7Ed7_mIpLmNtOkMeta } from "/codebuild/output/src2313071595/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeUVS0IYxU6Ydfw5REx8RQZ64VQbTOhgGZUaWcDvkMPVQMeta } from "/codebuild/output/src2313071595/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index58PbADkWIk6zAFSCrrxIbAAYFhDjECYgPGAfO9RpuTQMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexiWwXgrhIVimoxUgWtuBGiiRdwUb3SnXVnARXbmSMKHgMeta } from "/codebuild/output/src2313071595/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexX_458GgUNu1V8SD6wxsaCvCjzmB_LkaSHIC7ICBzdYNpIMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexxajdVlvaveh_boU70MGK80bF_45uJvGxFlHBaepLmmsssMeta } from "/codebuild/output/src2313071595/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update5ig8lsnhV88aLwwCgXG_2bF7DHVDz0zdd7jshTCUTt0Meta } from "/codebuild/output/src2313071595/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeIgpUTTDZsfp0IG4qhXPe4paQOZj2ZrYdBv0lDy2FVH4Meta } from "/codebuild/output/src2313071595/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmiOyxTje67HtquIEFXqWGUgJNLU3GmVKOOWwP98IEH0EMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexSzN0b6b_bdArjZF_45LyQb8SdcRLk3UK3EIriV2fQQo80Meta } from "/codebuild/output/src2313071595/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete9DZdc0peCXMQ60D3LsJ6zb0wPxAWSGhsAgHL6uwSlNEMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateSLRudCON6xV3pvwBUjrpfRuEOW7zBkk6u8vFTyVRc0AMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexljlIgrY2CTAid2oxz0_45m0MwbQVHOBa2EoC7Fdu1x6osMeta } from "/codebuild/output/src2313071595/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexgRZDLF47rHOFc1KdN0Ci_zLnH_45oLzFM7wjAghW1LhZ4Meta } from "/codebuild/output/src2313071595/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeCntE_tz7R3i0HP_459hYh0uu_45ImAI23boMW8ZUqG1ZeSIMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexI_45bRIh8ZGGJ4jby1PHy2jhzSUzy4RMz7fDQBVh5oQqUMeta } from "/codebuild/output/src2313071595/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeiAcM4vbn2_zPmr7A7bLDDYx8MfBQjRkpJzR8dnTdEeMMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index_LoOoKbdV6YmH_455K7rJjslUfm4iQX4mlW3ZmwPLxf_UMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexpZHwCEA6IUvbZhq_45TgiV4ZZRx6JuGjifHnHpQ_IOiEoMeta } from "/codebuild/output/src2313071595/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexGfK_45mLcWMbWMDAdfETSo0FfDuUwtef2umZ7rshYb_45UYMeta } from "/codebuild/output/src2313071595/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update5l1RZA1_45ev0xR_45qP972G17j2AxAiZwDGyfOxwMXzA5AMeta } from "/codebuild/output/src2313071595/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmxIso1nFyuyQxbNLxWy4ysfm7kfXiRs5hEPm6uQGg9V4Meta } from "/codebuild/output/src2313071595/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuqQlMEDvPcKB943_45yYAF52l4Hfmb3Yne3DV3lrb3N414Meta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexoVohuQXu_JBocmcsE1dUIFdbCFqTu1rm8rCpD1HGTPkMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index3Ie0WxQTbyVU24DKFw38rTOspsnqllldF907DPXE6ycMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2313071595/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexZQlSNW524h495Xh3smr8qWSdHR9wya_45Ry30xIDv8Ce4Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2313071595/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexoOTLeD5chTibuQfU_45fSDV7BJGE_znZR5Zh_45vKIRYz10Meta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index6rUMSoM6AXNjPV37111bkLAl20VNuyndd5XTvR7WkqIMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexskbMtuKhsLAPQJhMNSvouZfWVfMn4_6KHBEUBLrfpEAMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmbQeoYNiMbUNqh2IFls7t2D4TYpkvT_45CRr28JGWo0V2sMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmHQaWkGgQ46AsqE_e0icjAu2x8Yo_wLa5avHbCFwFn9EMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2313071595/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete4TsCusak5G4fSUNHSqoEEvRSfA5gdfmx9Zrl9YzUQ4wMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerPbrNiR2q7N9NZVOJ_BlQl3O_mzJFtih6tnibcVgWi6kMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmV8QwkuhLl4AxxmxFRQiN5J1thI3Nsc7XkfQs1GSzKagMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeYuy5CsXM431uxWyDbgpJVK7Cz4ZTNghgLQC06U3bzHAMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeVoqDKjH_4582Kjo16dK12mWfAvZGE_yQ3UCGdALAS7UrYMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completetyuUtbJUVwWtuHYh5NYlcaJ6lZDHD3dXsku5spozLHIMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerI6pXSx_45mILB7ARQD_QEJxWVv9xguUb7U4GPF6O9idgcMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmaIuAPsnK8jQl4I5N56JAo4mV4V8chLf8SlrXizITvqQMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completepF_45De4Oo2l1_45Vj7a97pCMUXUJm8ZVNhuJJRSi_45IFvLcMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexd6GySj83Af86sU_5n1ixIkO0Hw4j4r5XNBNVi21qtpAMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete2myI0Op9MA_zHXYviEiiU_f0GC9Gn0qqrMt5Zac5H5wMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampley7ySD_c4mU1kMsSeWjzbNwEDPYUtmm2l_45kY1rKCV0FYMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailx3SQ89qcwXSUEENUsSqwIT0KA0eKGfOE6KZSrVViFxQMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmOgSUQ_xkWg36hPnkUxKIbXf2KKBBGi3xFFWYBGdZpkAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentpt0yGOKsd_45BWld4_45m6JJwUYH_LXEGRUVlpNkFVPKhlcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm9FvGMjdW7ewZ4IpQKjKDVMGRiCkY4zTCUd_45VQwX36ScMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete_GxG6h_45Q70y_45sIQpxEnSnMN_Gdvt3isFbg7oqRZHulgMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code0Maw_45dTkcq7T5dyRk_452FZK1jOqZavBf58ZM_45NRlpzUUMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password8OTQIhELSxIVna3HCdSo_lwbcNeWmQ8L7EqYG8uGAkIMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerFwN1WLEz_45wXnBMZyjRe180qGDT9TN7Ed7_mIpLmNtOkMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeUVS0IYxU6Ydfw5REx8RQZ64VQbTOhgGZUaWcDvkMPVQMeta || {},
    component: () => import("/codebuild/output/src2313071595/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2313071595/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]